/***
 * @Author: hippo
 * @Date: 2024-01-15 10:54:37
 * @LastEditors: hippo
 * @LastEditTime: 2025-02-04 21:40:35
 * @Description: 
 * @
 */
import React, { useState, useCallback, useMemo, forwardRef } from 'react'
import { Button, Cascader, message } from 'antd'
import { useMount } from 'react-use'
import regions, { denormalizeCode, normalizeCode } from '@/utils/regions';
import styles from './selectArea.module.scss'

const options = regions.provinces;

window.__xxoptions = options

// Just show the latest item.
function displayRender(label, selectedOptions) {
  return label.join('-');
}

/**
 * Just select
 * @param {*} param0
 */
export function Select({ value,  onChange, ...props }) {
  const regionArr = useMemo(() => denormalizeCode(value), [value])
  const changeHandler = useCallback(val => onChange(normalizeCode(val)), [])

  return (
    <div className={styles.item}>
      <Cascader
        allowClear={false}
        options={options}
        autoComplete="off"
        placeholder="请选择地址"
        fieldNames={{ label: 'name', value: 'code', children: 'childs' }}
        value={regionArr}
        displayRender={displayRender}
        onChange={changeHandler}
        {...props} />
      <Button
        size="small"
        shape="circle"
        onClick={() => onChange(null)}
        className={styles.clearBtn}>
        ×
      </Button>
    </div>
  )
}

export default forwardRef(function SelectArea({ value, onChange }, ref) {
  const [list, setList] = useState([])
  const onItemChange = useCallback(idx => val => {
    if (list.includes(val)) {
      return message.info('已重复')
    }

    const data = [...list]
    if (!val) {
      data.splice(idx, 1)
    } else {
      data[idx] = val
    }

    setList(data)
    onChange(data.filter(Boolean))
  }, [list])
  const addNewItem = useCallback(() => {
    if (list.length >= 5) {
      return message.warn('不得超过5个')
    }
    setList([...list, []])
  }, [list])

  useMount(() => {
    value && setList(value)
  })

  return (
    <div ref={ref}>
      {
        list.map((value, idx) => (
          <Select value={value} onChange={onItemChange(idx)} />
        ))
      }
      <Button
        type="primary"
        shape="circle"
        icon="plus"
        onClick={addNewItem} />
    </div>
  )
})
